import { css } from "@emotion/css";
import { QuizDefinition } from "src/quiz";
import { danger } from "src/ui/colors";
import { SubmissionState } from "src/ui/SubmissionState";
import { createAllBlankAnswerSet, score, totalScore } from "./answer-utils";
import { buttonCss } from "./buttonCss";

export function DemoScorePanel({
  quiz, sharedData, submissionState, setShowSolutions,
}: {
  quiz: QuizDefinition;
  sharedData: Record<string, string>;
  submissionState: SubmissionState;
  setShowSolutions: (value: boolean) => void;
}) {
  const allBlankAnswers = createAllBlankAnswerSet(quiz);

  return (
    <>
      <div
        className={css`
          display: flex;
          flex-flow: column;
          gap: 0.25rem;
          border-radius: 0.5rem;
          border: 1px solid rgb(127 127 127 / 30%);
          box-shadow: 0 0 0.5rem 0 rgb(127 127 127 / 15%);
          transition: background-color 150ms;
          background-color: white;
          padding: 0.25rem 0.5rem;
        `}
      >
        <div
          className={css`
            font-size: 0.75rem;
            line-height: 0.75rem;
          `}
        >
          Il tuo punteggio:
        </div>
        <div
          className={css`
            font-size: 1.25rem;
            line-height: 1.25rem;
            text-align: center;
          `}
        >
          <strong
            className={css`
              font-size: 1.5rem;
            `}
          >
            {score(quiz, sharedData, submissionState.submittedAnswers ?? allBlankAnswers)}
          </strong>{" "}
          / {totalScore(quiz)}
        </div>
      </div>
      <button
        type="button"
        className={css`
          background-color: ${danger};
          ${buttonCss}
        `}
        onClick={() => {
          setShowSolutions(false);
          submissionState.setAnswers(allBlankAnswers);
          submissionState.updateSubmission(allBlankAnswers);
        }}
      >
        Azzera e riprova
      </button>
    </>
  );
}
